<template>
  <header class="apple-toolbar" :class="{ 'is-settings': $route.name === 'settings' || $route.name === 'account' && $route.query.from === 'settings', 'is-browse': browseToolbar, 'is-library-wide': libraryWideToolbar, 'is-artist': artistToolbar, 'is-compact': !browseToolbar && !artistToolbar, 'is-searching': searchingToolbar }" aria-label="应用工具栏">
    <div class="apple-toolbar-heading">
      <button id="apple-navigation-trigger" class="apple-toolbar-menu" type="button" aria-label="打开导航菜单" :aria-expanded="String(navigationUI.mobile && navigationUI.open)" aria-controls="apple-sidebar" @click="openNavigation"><span aria-hidden="true">☰</span></button>
      <div class="apple-history-controls">
        <button type="button" aria-label="后退" @click="$router.back()">‹</button>
        <button type="button" aria-label="前进" @click="$router.forward()">›</button>
      </div>
      <strong>{{ title || contextLabel }}</strong>
    </div>
    <Navbar class="apple-navbar" :apple-compact-search="!browseToolbar && !libraryWideToolbar && !artistToolbar && !searchingToolbar"><template #before-avatar><AppleNotifications v-if="!navigationUI.mobile" /></template></Navbar>
    <span v-if="browseToolbar" class="apple-toolbar-user-name" :title="site.user ? (site.user.nickname || site.user.username) : '账号与登录'">{{ site.user ? (site.user.nickname || site.user.username) : '账号与登录' }}</span>
  </header>
</template>

<script>
import Navbar from '../components/Navbar.vue';
import AppleNotifications from './AppleNotifications.vue';
import { workspace, navigationUI, openNavigation } from '../workspace';
import { runtime } from '../bridge';
import { search } from '../search';
import { siteAccount } from '../site-account';
export default {
  name: 'AppleToolbar',
  props: { title: { type: String, default: '' } },
  components: { Navbar, AppleNotifications },
  data() { return { workspace, navigationUI, runtime, search, site: siteAccount }; },
  computed: {
    browseToolbar() { return ['home', 'explore', 'cloud'].includes(this.$route.name); },
    searchingToolbar() { return this.search.open || this.search.mobileExpanded; },
    artistToolbar() { return this.$route.name === 'artist'; },
    libraryWideToolbar() { return !this.searchingToolbar && this.$route.name === 'library' && ['artists', 'playlists', 'collections', 'folders', 'recentAdded', 'manage', 'cloudDisk'].includes(this.$route.query.tab); },
    contextLabel() {
      const labels = { home: '首页', explore: '发现音乐', cloud: '我的云盘', library: '音乐库', account: '账号与登录', settings: '设置' };
      return labels[this.$route.name] || 'Simple Music';
    },
  },
  methods: { openNavigation },
};
</script>
<style scoped>
.apple-toolbar-menu { display:none; }
.apple-toolbar-user-name { display:block; flex:none; max-width:120px; overflow:hidden; color:var(--color-text); font-size:16px; font-weight:500; text-overflow:ellipsis; white-space:nowrap; }
#app.apple-shell.salt-mobile-layout .apple-toolbar { left:0!important; gap:8px; padding-left:max(8px,env(safe-area-inset-left,0px)); padding-right:max(12px,env(safe-area-inset-right,0px)); }
#app.apple-shell.salt-mobile-layout .apple-toolbar-heading { display:flex; min-width:0; gap:8px; }
#app.apple-shell.salt-mobile-layout .apple-toolbar-menu { display:grid; place-items:center; width:44px; height:44px; flex:none; }
#app.apple-shell.salt-mobile-layout .apple-history-controls { display:none; }
#app.apple-shell.salt-mobile-layout .apple-toolbar-heading strong { display:block;  overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
#app.apple-shell.salt-mobile-layout .apple-toolbar-user-name { display:none; }
</style>
